// Import relativ (nu alias @/) ca spec-ul să ruleze fără config de alias în vitest.
import { formatNumber } from '../../../shared/utils/number-format';

export interface AmountParts {
  /** Partea mare: întregul cu separatorii de mii (ex. „122.035" / „122,035"). */
  main: string;
  /** Zecimalele CU separatorul zecimal al formatului activ (ex. „,11" / „.11"). */
  decimals: string;
}

/**
 * Desparte o sumă formatată în „parte mare + zecimale mici" pentru cifrele KPI.
 *
 * Bug-ul pe care îl înlocuiește (incident 2026-07-23): `split('.')` presupunea
 * formatul en-US („122,035.11"). Pe formatul românesc („122.035,11") rupea la
 * separatorul de MII → „122" mare + „.035,11" mic, iar la valori sub 1000
 * („727,93") fabrică un „.00" inexistent → „727,93.00".
 */
export function splitFormattedAmount(full: string): AmountParts {
  const m = full.match(/^(.*)([.,]\d{2})$/);
  if (!m) return { main: full, decimals: '' };
  return { main: m[1]!, decimals: m[2]! };
}

export function splitAmount(n: number): AmountParts {
  return splitFormattedAmount(formatNumber(n, 2));
}
